import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import moment from 'moment';
import Spinner from '../../common/Spinner/Spinner';
import PatientRescheduledInformationDialogHeader from './PatientRescheduledInformationDialogHeader';
import globals from '../../../globals/communityGlobals';
import { nursing500 } from '../../../theme/AllocateColors';

const locale = globals.getArea('patients');
class PatientRescheduledInformationDialog extends React.Component {
  checkVisibility = dialog => (dialog ? dialog.isVisible : false);

  formatDate = date => (date ? moment(date).format(globals.dateFormats.long) : '');

  render() {
    const { isFetching, dialogs, id, hide, rescheduledInfo } = this.props;
    const dialog = dialogs[id];

    const contentWidth = '640px';
    const contentWidthPadded = '660px';
    const contentHeight = '310px';

    const isSpinning = isFetching || !rescheduledInfo;

    const closeButtonStyle = {
      textTransform: 'initial',
      color: nursing500,
    };
    return (
      <Dialog
        modal={false}
        open={this.checkVisibility(dialog)}
        onRequestClose={() => hide(id)}
        autoScrollBodyContent
        contentStyle={{ width: contentWidthPadded, maxWidth: contentWidth }}
        className="dialog"
        bodyClassName="BodyClass"
        contentClassName="ContentClass"
        aperClassName="paperClass"
        titleClassName="TitleClass"
      >
        <div
          style={{
            maxWidth: contentWidthPadded,
            height: contentHeight,
            minHeight: contentHeight,
            maxHeight: contentHeight, // info: without this dialog jumps
          }}
        >
          {isSpinning ? (
            <Spinner />
          ) : (
            <div>
              <PatientRescheduledInformationDialogHeader onClose={() => hide(id)}>
                {' '}
                {locale.getMsg('rescheduledVisitInformation')}
              </PatientRescheduledInformationDialogHeader>
              <div className="dialog-content">
                <div className="row">
                  <div className="col-c12">
                    <h5>{locale.getMsg('reason')}</h5>
                    <span>{this.props.rescheduledInfo.reason}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-c12">
                    <h5>{locale.getMsg('riskAssesment')}</h5>
                    <span>{this.props.rescheduledInfo.riskAssessment}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-c4">
                    <h5>{locale.getMsg('rescheduleDate')}</h5>
                    <span>{this.formatDate(this.props.rescheduledInfo.rescheduledDate)}</span>
                  </div>
                  <div className="col-c4">
                    <h5>{locale.getMsg('rescheduleTo')}</h5>
                    <span>{this.formatDate(this.props.rescheduledInfo.rescheduledTo)}</span>
                  </div>
                  <div className="col-c4">
                    <h5>{locale.getMsg('rescheduleVisitDuration')}</h5>
                    <span>
                      {this.props.rescheduledInfo.mins} {locale.getMsg('mins')}
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-c12">
                    <FlatButton label={locale.getMsg('close')} labelStyle={closeButtonStyle} onClick={() => hide(id)} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

PatientRescheduledInformationDialog.defaultProps = {
  rescheduledInfo: null,
};

PatientRescheduledInformationDialog.propTypes = {
  hide: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  dialogs: PropTypes.objectOf(
    PropTypes.shape({
      isVisible: PropTypes.bool,
    }),
  ).isRequired,
  isFetching: PropTypes.bool.isRequired,
  rescheduledInfo: PropTypes.shape({
    reason: PropTypes.string,
    riskAssessment: PropTypes.string,
    clinicianThatRescheduled: PropTypes.string,
    rescheduledDate: PropTypes.string,
    rescheduledTo: PropTypes.string,
    mins: PropTypes.number,
  }),
};

export default PatientRescheduledInformationDialog;
